<template lang="html">
  <v-dialog
    v-model="opened"
    width="800"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="
      $emit('update:opened', false);
      tags = selectedTags;
    "
    @keydown.enter="$emit('save-document-tags', tags)"
  >
    <v-card block flat>
      <v-card-title class="subheading">
        {{
          selectedItem
            ? `Update Tags for ${selectedItem.name}`
            : "Update Firm's Document Tags"
        }}
      </v-card-title>
      <v-card-text class="text-xs-left subheading">
        <v-layout xs12 v-if="selectedItem">
          <v-autocomplete
            class="default-input"
            :items="
              selectedTags.length === 0
                ? firmDocumentsTag
                : firmDocumentsTag.concat(selectedTags)
            "
            v-model="selectedTags"
            placeholder="No Tags"
            solo
            chips
            small-chips
            multiple
          />
        </v-layout>
        <v-layout wrap v-else>
          <span v-if="isEmpty(firmDocumentsTag)" class="my-2 grey--text ml-2"
            >None</span
          >
          <v-chip
            v-else
            small
            align-center
            v-for="(tag, i) in firmDocumentsTag"
            :key="i"
            >{{ tag
            }}<v-icon
              @click="removeTag(tag)"
              class="ml-2"
              size="15"
              style="cursor: pointer"
              >clear</v-icon
            ></v-chip
          >
        </v-layout>
        <v-divider class="my-4" />
        <v-layout align-center>
          <v-text-field
            v-model="newTag"
            hide-details
            class="default-input"
            solo
            placeholder="New Tag Name"
          />
          <v-btn
            class="primary text-none"
            @click="createDocumentTag()"
            :disabled="isEmpty(newTag)"
          >
            Create Document Tag
          </v-btn>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="primary text-none"
          @click="$emit('save-document-tags', selectedTags)"
          v-if="selectedItem"
        >
          Save
        </v-btn>
        <v-btn
          class="error--text text-none"
          flat
          @click="
            $emit('update:opened', false);
            tags = [];
          "
        >
          {{ selectedItem ? 'Cancel' : 'Close' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import API from '@/api';
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';

export default {
  name: 'EditDocumentTagDialog',
  props: {
    opened: {
      type: Boolean,
    },
    selectedItem: {
      type: Object,
    },
  },
  data() {
    return {
      newTag: '',
      selectedTags: [],
    };
  },
  computed: {
    ...mapGetters(['currentFirm']),
    firmDocumentsTag() {
      if (this.currentFirm) {
        return this.currentFirm.document_tags;
      } else {
        return [];
      }
    },
  },
  methods: {
    moment,
    isEmpty,
    async createDocumentTag() {
      if (
        !this.selectedItem &&
        this.currentFirm.document_tags.includes(this.newTag)
      ) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Tag already exists',
        });
        return;
      } else if (!this.currentFirm.document_tags.includes(this.newTag)) {
        try {
          const response = await API.firm.addDocumentTag(this.newTag);
          if (response.data.error) {
            this.$store.dispatch('application/setErrorNotification', {
              message: response.data.error,
            });
          } else {
            this.$store.dispatch('application/setSuccessNotification', {
              message: 'Tag created!',
            });
            await this.$store.dispatch('setCurrentFirm');
            if (this.selectedItem) {
              this.selectedTags.push(this.newTag);
            }
          }
          this.newTag = '';
        } catch (e) {
          console.log(e);
          this.$store.dispatch('application/setErrorNotification', {
            message:
              'There was a problem adding the tag. Please try again after refreshing the page.',
          });
        }
      }
    },
    async removeTag(tag) {
      try {
        const response = await API.firm.removeDocumentTag(tag);
        console.log(response.data);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Tag deleted!',
          });
          await this.$store.dispatch('setCurrentFirm');
        }
        this.newTag = '';
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the tag. Please try again after refreshing the page.',
        });
      }
    },
  },
  watch: {
    selectedItem: {
      handler(value) {
        if (value) {
          this.selectedTags = value.tags ? value.tags : [];
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped></style>
